import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AccommodationBookedForForm.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import NumberInput from '../../../../../../moreCore/UI/NumberInput/NumberInput';
import DateTimeInput from '../../../../../../moreCore/UI/DateTimeInput/DateTimeInput';
import { BookedForLoadData } from "../../../TravelBookingListTypes";
import { AccommodationBookedForData } from "../../BookedForFormTypes";
import HintBox from '../../../../../../moreCore/UI/HintBox/HintBox';
import Edit from '../../../../../../moreCore/UI/Edit/Edit';
import SearchSelect from '../../../../../../moreCore/UI/SearchSelect/SearchSelect';
import lang from 'dojo/_base/lang';
import CheckBox from '../../../../../../moreCore/UI/CheckBox/CheckBox';
import _GlobalSelectEntityDialogsMixin from '../../../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../../../moreCore/_loadingHelpers/SelectEntityDialog";

class AccommodationBookedForForm extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private quantityNightsInput: MdsLax<InstanceType<typeof NumberInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private roomTypeInput: MdsLax<InstanceType<typeof HintBox>>;
    private roomNoInput: MdsLax<InstanceType<typeof Edit>>;
    private qtyRoomsInput: MdsLax<InstanceType<typeof NumberInput>>;
    private isOversteeredPriceInput: MdsLax<InstanceType<typeof CheckBox>>;
    private priceA01Input: MdsLax<InstanceType<typeof NumberInput>>;
    private qtyA01Input: MdsLax<InstanceType<typeof NumberInput>>;
    private priceA02Input: MdsLax<InstanceType<typeof NumberInput>>;
    private qtyA02Input: MdsLax<InstanceType<typeof NumberInput>>;
    private priceBreakfastInput: MdsLax<InstanceType<typeof NumberInput>>;
    private isBreakfastInput: MdsLax<InstanceType<typeof CheckBox>>;
    private pricePerUnitInput: MdsLax<InstanceType<typeof NumberInput>>;
    private accommodationCalcModeInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private priceTotalInput: MdsLax<InstanceType<typeof NumberInput>>;
    private termsOfPaymentInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private isActiveInput: MdsLax<InstanceType<typeof CheckBox>>;
    private isStandbyInput: MdsLax<InstanceType<typeof CheckBox>>;

    private originalData: BookedForLoadData;


    getData(): AccommodationBookedForData {
        var data: AccommodationBookedForData = {
            date_start: this.dateToLocalISOString(this.dateStartInput.getValue().date),
            qty_nights: this.quantityNightsInput.getValue(),
            date_end: this.dateToLocalISOString(this.dateEndInput.getValue().date),
            ref_accommodation_roomtype: this.roomTypeInput.getValue("entity"),
            c_accommodation_roomtype: this.roomTypeInput.getValue("plaintext"),
            is_oversteered_price: this.isOversteeredPriceInput.getValue(),
            price_a01: this.priceA01Input.getValue() ? this.priceA01Input.getValue() : 0,
            qty_A01: this.qtyA01Input.getValue() ? this.qtyA01Input.getValue() : 0,
            price_a02: this.priceA02Input.getValue() ? this.priceA02Input.getValue() : 0,
            qty_A02: this.qtyA02Input.getValue() ? this.qtyA02Input.getValue() : 0,
            is_breakfast: this.isBreakfastInput.getValue(),
            price_per_unit: this.pricePerUnitInput.getValue(),
            price_total: this.priceTotalInput.getValue(),
            accomodation_calc_mode: this.accommodationCalcModeInput.getValue(),
            ref_travel_terms_of_payment: this.termsOfPaymentInput.getValue(true),
            c_travel_terms_of_payment: this.termsOfPaymentInput.getValue(true)?.description,
            is_active: this.isActiveInput.getValue(),
            is_standby: this.isStandbyInput.getValue(),
            price_breakfast: this.priceBreakfastInput.getValue(),
            room_no: this.roomNoInput.getValue(),
            qty_rooms: this.qtyRoomsInput.getValue()
        }
        return data;
    }

    setData(entity: BookedForLoadData) {
        this.originalData = entity;

        this.dateStartInput.setValue(entity.ref_vt_travel.date_start, true);
        this.quantityNightsInput.setValue(entity.qty_nights, true);
        this.dateEndInput.setValue(entity.ref_vt_travel.date_end, true);
        this.roomTypeInput.setValue(entity.ref_accommodation_roomtype ? entity.ref_accommodation_roomtype : entity.c_accommodation_roomtype, true);
        this.qtyRoomsInput.setValue(entity.qty_rooms, true);
        this.isOversteeredPriceInput.setValue(entity.is_oversteered_price);
        this.priceA01Input.setValue(entity.price_a01, true);
        this.qtyA01Input.setValue(entity.qty_A01, true);
        this.priceA02Input.setValue(entity.price_a02, true);
        this.qtyA02Input.setValue(entity.qty_A02, true);
        this.isBreakfastInput.setValue(entity.is_breakfast, true);
        this.pricePerUnitInput.setValue(entity.price_per_unit, true);
        this.priceTotalInput.setValue(entity.price_total, true);
        this.accommodationCalcModeInput.setValue(entity.accomodation_calc_mode, true);
        this.termsOfPaymentInput.setValue(entity.ref_travel_terms_of_payment, true);
        this.isActiveInput.setValue(entity.is_active, true);
        this.roomNoInput.setValue(entity.room_no, true)
        this.priceBreakfastInput.setValue(entity.price_breakfast, true);
        this.isStandbyInput.setValue(entity.is_standby, true);


        this.dateStartInput.setReadonly(true);
        this.dateEndInput.setReadonly(true);
        this.quantityNightsInput.setReadonly(true);
    }

    private _onChangeIsPriceOversteered(e) {
        this.priceA01Input.setReadonly(!e);
        this.priceA02Input.setReadonly(!e);
        this.priceBreakfastInput.setReadonly(!e);
        this.accommodationCalcModeInput.setReadonly(!e);
        this.resetRoomPrices();
    }



    private _onClickSEDButton(mode: string, evt: MouseEvent) {
        this.openSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<more.EntityAPIResultExtended>>) {
        if (items && items.length > 0) {
            switch (mode) {
                case "accommodation_roomtype":
                    this.roomTypeInput.setValue(items[0].entry.data);
                    break;
            }
        }
    }

    private _onInputChange(e) {
        this.emit("change", e);
    }

    private _onInputChangeTotalPrice(e) {
        this.calculateTotalPrice();
        this._onInputChange(e);
    }

    private _onInputChangeResetPrice(e) {
        this.resetRoomPrices();
        this._onInputChange(e);
    }


    setQtyPersons(qtyPersons: number): void {
        this.originalData["qty_persons"] = qtyPersons;
    }

    resetRoomPrices() {
        let currentData = this.getData();
        if (currentData.is_oversteered_price || !currentData.ref_accommodation_roomtype || !this.originalData.qty_persons || !this.originalData.date_start_DMY) return;

        let roomPriceList = currentData.ref_accommodation_roomtype.EL_accommodation_room_price_accommodation_roomtype ? currentData.ref_accommodation_roomtype.EL_accommodation_room_price_accommodation_roomtype :  [];
        let newCalcmode = currentData.ref_accommodation_roomtype.accomodation_calc_mode;

        this.accommodationCalcModeInput.setValue(newCalcmode, true);

        roomPriceList?.sort((a, b) => {
            return a.date_valid_from.getTime() - b.date_valid_from.getTime();
        });


        let qtyInRoom = 0;
        let listBookedForSameRoom = this.originalData.EL_accomodation_booked_for_roommate;
        for (let bookedFor of listBookedForSameRoom) {
            if (bookedFor.is_active) qtyInRoom += bookedFor.qty_persons;
        }
        qtyInRoom += this.originalData.qty_persons;

        for (let roomPrice of roomPriceList) {
            if (this.originalData.date_start >= roomPrice.date_valid_from && this.originalData.date_start <= roomPrice.date_valid_until) {
                if (qtyInRoom == 1 || roomPrice.ref_accommodation_roomtype.qty_max_persons_in_room == 1) {
                    this.priceA01Input.setValue(roomPrice.price_1_single_occupation, true);
                    this.priceA02Input.setValue(roomPrice.price_2_single_occupation, true);
                } else {
                    this.priceA01Input.setValue(roomPrice.price_1_double_occupation, true);
                    this.priceA02Input.setValue(roomPrice.price_2_double_occupation, true);
                }
                this.priceBreakfastInput.setValue(roomPrice.price_breakfast, true);
                if (!currentData.is_breakfast && roomPrice.is_breakfast) this.isBreakfastInput.setValue(roomPrice.is_breakfast, true);
                return;
            }
        }

        this._onInputChangeTotalPrice(null);
    }

    calculateTotalPrice() {
        let currentData = this.getData();

        let priceTotal = 0;
        let priceUnit = 0;

        //if (currentData.is_oversteered_price || !currentData.ref_accommodation_roomtype || !this.originalData.qty_persons || !this.originalData.date_start_DMY) return;

        if (currentData.is_breakfast) priceTotal += currentData.price_breakfast * this.originalData.qty_persons * this.originalData.qty_nights;
        switch (currentData.accomodation_calc_mode) {
            case "R":
                priceTotal += ((currentData.price_a01 * currentData.qty_A01) + (currentData.price_a02 * currentData.qty_A02)) * currentData.qty_rooms;
                if (currentData.qty_rooms && this.originalData.qty_nights) priceUnit = priceTotal / currentData.qty_rooms / this.originalData.qty_nights;
                break;
            case "P":
                var newQtyPersons = this.originalData.qty_persons ? this.originalData.qty_persons : 0;
                for (let bookedFor of this.originalData.EL_accomodation_booked_for_roommate) {
                    if (bookedFor.is_active) newQtyPersons += bookedFor.qty_persons;
                }
                priceTotal += ((currentData.price_a01 * currentData.qty_A01) + (currentData.price_a02 * currentData.qty_A02)) * newQtyPersons;
                if (currentData.qty_rooms && this.originalData.qty_nights) priceUnit = priceTotal / currentData.qty_rooms / this.originalData.qty_nights;
                break;
            case "T":
                priceTotal += currentData.price_a01 + currentData.price_a02;
                priceUnit += priceTotal;
                break;
        }

        if (!priceTotal || !this.originalData.qty_nights || !this.originalData.qty_persons) {
            priceUnit = null;
            priceTotal = null;
        }
        this.pricePerUnitInput.setValue(priceUnit, true);
        this.priceTotalInput.setValue(priceTotal, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.isOversteeredPriceInput.on("change", lang.hitch(this, this._onChangeIsPriceOversteered));

        this.termsOfPaymentInput.loadListValues();
        this.accommodationCalcModeInput.loadListValues();

        this.SEDconfigCallfunction = "Webtool_API__TravelBookingForm_SED_GetConfig";

        this.roomTypeInput.addInlineButton(lang.hitch(this, this._onClickSEDButton, "accommodation_roomtype"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AccommodationBookedForForm);